// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"8d36cc61","312":"b97a12a5","313":"180ae6fa","420":"1cc17126","652":"2b9d7574","714":"d8052ce7","855":"d2368923"}[chunkId] + ".css";
};